module.exports = __webpack_public_path__ + "static/media/luckywheel_bg.828f76ce.jpg";